<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel)"
    :name="MODAL_NAMES.BOUYGUES"
    :title="i18n(translations.title)"
  >
    <template #body>
      <BouyguesOffers :offers />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import BouyguesOffers from '~/scopes/partnerships/components/BouyguesOffers/BouyguesOffers.vue'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './BouyguesOffersDrawer.translations'

const i18n = useI18n()

defineProps<{
  offers:
    | MobilePlanOffer[]
    | GetProductResponse['includedServiceOffers']['mobilePlans']
}>()
</script>
